import React, { useState } from 'react';
import './VPSWindows.css';

const VPSWindows = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شخصی',
      price: '۳۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '2 Core',
      ram: '۴ GB',
      storage: '۵۰ GB NVMe',
      bandwidth: '۱ TB',
      features: ['لایسنس ویندوز', 'RDP Access', 'پشتیبانی ۲۴/۷', 'آپتایم ۹۹.۹٪'],
      popular: false,
    },
    {
      tier: 'کسب‌وکار',
      price: '۵۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '4 Core',
      ram: '۸ GB',
      storage: '۱۰۰ GB NVMe',
      bandwidth: '۲ TB',
      features: ['لایسنس ویندوز', 'RDP Access', 'پشتیبانی ۲۴/۷', 'آپتایم ۹۹.۹٪', 'MSSQL'],
      popular: true,
    },
    {
      tier: 'سازمانی',
      price: '۹۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '8 Core',
      ram: '۱۶ GB',
      storage: '۲۰۰ GB NVMe',
      bandwidth: '۴ TB',
      features: ['لایسنس ویندوز', 'RDP Access', 'پشتیبانی ۲۴/۷', 'آپتایم ۹۹.۹٪', 'MSSQL', 'IP اختصاصی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🪟',
      title: 'لایسنس رسمی ویندوز',
      desc: 'VPS ویندوز افرسل با لایسنس رسمی مایکروسافت ارائه می‌شود. شما می‌توانید از تمام قابلیت‌های ویندوز سرور استفاده کنید و از امنیت و پشتیبانی کامل بهره‌مند شوید.',
    },
    {
      icon: '🖥️',
      title: 'دسترسی RDP و کنترل کامل',
      desc: 'دسترسی کامل از طریق Remote Desktop Protocol (RDP) به سرور ویندوز خود داشته باشید. مانند یک کامپیوتر فیزیکی، سرور خود را مدیریت کنید و هر نرم‌افزاری را نصب نمایید.',
    },
    {
      icon: '🗄️',
      title: 'پشتیبانی از MSSQL و ASP.NET',
      desc: 'VPS ویندوز با پشتیبانی کامل از MSSQL و ASP.NET، برای اپلیکیشن‌های دات‌نت و وب‌سایت‌های سازمانی گزینه‌ای ایده‌آل است.',
    },
    {
      icon: '🎛️',
      title: 'کنترل پنل Plesk',
      desc: 'امکان نصب کنترل پنل Plesk برای مدیریت آسان وب‌سایت، ایمیل و پایگاه داده. با رابط کاربری ساده و قدرتمند.',
    },
  ];

  const faqs = [
    {
      q: 'VPS ویندوز چه تفاوتی با VPS لینوکس دارد و برای چه پروژه‌هایی مناسب است؟',
      a: 'VPS ویندوز با سیستم‌عامل Windows Server و پشتیبانی از فناوری‌های مایکروسافت مانند ASP.NET، MSSQL و IIS طراحی شده است. این نوع VPS برای اپلیکیشن‌های دات‌نت، وب‌سایت‌های سازمانی و پروژه‌هایی که به محیط ویندوز نیاز دارند، ضروری است. همچنین برای سازمان‌هایی که از اکوسیستم مایکروسافت استفاده می‌کنند، گزینه‌ای ایده‌آل محسوب می‌شود. در مقابل، VPS لینوکس برای اکثر وب‌سایت‌ها و اپلیکیشن‌های مبتنی بر PHP، Python و Node.js مناسب است.',
    },
    {
      q: 'آیا VPS ویندوز از دسکتاپ ریموت پشتیبانی می‌کند؟',
      a: 'بله، VPS ویندوز افرسل با پشتیبانی کامل از RDP (Remote Desktop Protocol)، شما می‌توانید از هر جای دنیا به سرور خود متصل شوید و مانند یک کامپیوتر فیزیکی آن را مدیریت کنید. این ویژگی برای مدیریت آسان سرور و نصب نرم‌افزارهای مختلف بسیار مفید است.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>VPS ویندوز | خرید سرور مجازی ویندوز با بهترین قیمت | افرسل</h1>
        <p>خرید VPS ویندوز با لایسنس رسمی، RDP Access و پشتیبانی ۲۴ ساعته. سرور مجازی ویندوز مناسب برای اپلیکیشن‌های دات‌نت، MSSQL و وب‌سایت‌های سازمانی.</p>
        <meta name="description" content="خرید VPS ویندوز با بهترین قیمت از افرسل. سرور مجازی ویندوز با لایسنس رسمی، RDP Access، MSSQL و پشتیبانی ۲۴/۷." />
      </div>

      <section className="vps-windows-hero">
        <div className="vps-windows-hero-bg"></div>
        <div className="wrap">
          <div className="vps-windows-hero-content">
            <div className="vps-windows-badge">
              <span className="pulse-dot"></span>
              🪟 VPS ویندوز
            </div>
            <h1 className="vps-windows-hero-title">
              سرور مجازی <em>ویندوز</em>
            </h1>
            <p className="vps-windows-hero-desc">
              VPS ویندوز با لایسنس رسمی، دسترسی RDP و پشتیبانی ۲۴ ساعته.
              مناسب برای اپلیکیشن‌های دات‌نت، MSSQL و وب‌سایت‌های سازمانی.
            </p>
            <div className="vps-windows-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">RDP</span>
                <span className="stat-label">دسترسی کامل</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">MSSQL</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vps-windows-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های VPS ویندوز</span>
            <h2 className="sec-h">پلن <em>مناسب</em> پروژه خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع VPS ویندوز با قیمت‌های رقابتی و منابع کافی برای هر نوع پروژه.</p>
          </div>
          <div className="vps-windows-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`vps-windows-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="vps-windows-popular-badge">پرفروش‌ترین</span>}
                <div className="vps-windows-plan-tier">{plan.tier}</div>
                <div className="vps-windows-plan-price">
                  <span className="vps-windows-plan-num">{plan.price}</span>
                  <span className="vps-windows-plan-unit">{plan.unit}</span>
                </div>
                <div className="vps-windows-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                  <div><span>📶</span> {plan.bandwidth}</div>
                </div>
                <ul className="vps-windows-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="vps-windows-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-windows-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای VPS ویندوز</span>
            <h2 className="sec-h">چرا <em>VPS ویندوز</em> با افرسل؟</h2>
            <p className="sec-p">VPS ویندوز با بهترین امکانات و خدمات برای اپلیکیشن‌های دات‌نت و وب‌سایت‌های سازمانی.</p>
          </div>
          <div className="vps-windows-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="vps-windows-feature-card">
                <span className="vps-windows-feature-icon">{feature.icon}</span>
                <h3 className="vps-windows-feature-title">{feature.title}</h3>
                <p className="vps-windows-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-windows-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="vps-windows-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="vps-windows-faq-item">
                <div className="vps-windows-faq-q">{faq.q}</div>
                <div className="vps-windows-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-windows-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              VPS <em>ویندوز</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید VPS ویندوز، از سرعت بالا، پایداری عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید VPS</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VPSWindows;
